import { Controller } from "@hotwired/stimulus"

// Used on CSV/XLSX export buttons (see shared/_data_table_export_buttons).
// Exports are real browser downloads (data: { turbo: false } links), not AJAX
// requests, so we have no "request finished" callback to hook into. Instead:
//   - On the first click, let the download start normally, disable the
//     buttons, and show a "Generating export..." notice.
//   - Any click while an export is in flight is ignored, to prevent a user
//     from firing a second multi-second query while the first is still
//     running.
//   - Re-enable everything after resetDelayValue ms as a safety net, in case
//     the browser never gives us any other signal (e.g. the response was an
//     error page rather than a file download).
export default class extends Controller {
  static targets = ["link", "toast"]
  static values = {
    resetDelay: { type: Number, default: 8000 }
  }

  connect() {
    this.exporting = false
    this.resetTimeout = null
  }

  disconnect() {
    this.clearResetTimeout()
  }

  startExport(event) {
    if (this.exporting) {
      event.preventDefault()
      return
    }

    this.exporting = true
    this.linkTargets.forEach((link) => {
      link.classList.add("disabled")
      link.style.pointerEvents = "none"
      link.blur()
    })
    this.showToast()

    this.clearResetTimeout()
    this.resetTimeout = setTimeout(() => this.reset(), this.resetDelayValue)
  }

  reset() {
    this.exporting = false
    this.linkTargets.forEach((link) => {
      link.classList.remove("disabled")
      link.style.pointerEvents = ""
    })
    this.hideToast()
  }

  showToast() {
    if (!this.hasToastTarget) return
    this.toastTarget.style.display = ""
  }

  hideToast() {
    if (!this.hasToastTarget) return
    this.toastTarget.style.display = "none"
  }

  clearResetTimeout() {
    if (!this.resetTimeout) return
    clearTimeout(this.resetTimeout)
    this.resetTimeout = null
  }
}
